import createSvgIcon from '@mui/material/utils/createSvgIcon.js';
import React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="M16.59 14.41 13 10.83V21h-2V10.83l-3.59 3.59L6 13l6-6 6 6zM18 6H6V4h12z"
  />,
  'Upload',
);
